import '../sass/awards-carousel.scss';

function initAwardsCarouselSwipers() {
    document.querySelectorAll('.js-awards-carousel-swiper').forEach((el) => {
        const wrap = el.closest('.awards-carousel__swiper-wrap');
        const paginationEl = wrap?.querySelector('.awards-carousel__pagination');
        const prevEl = el.querySelector('.awards-carousel__nav-prev');
        const nextEl = el.querySelector('.awards-carousel__nav-next');

        if (!wrap || !paginationEl || !prevEl || !nextEl) {
            return;
        }

        const slideCount = el.querySelectorAll('.swiper-slide').length;

        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 24,
            speed: 600,
            watchOverflow: true,
            rewind: slideCount > 1,
            autoplay:
                slideCount > 1
                    ? {
                          delay: 5000,
                          disableOnInteraction: false,
                      }
                    : false,
            pagination: {
                el: paginationEl,
                clickable: true,
            },
            navigation: {
                prevEl,
                nextEl,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 28,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAwardsCarouselSwipers);
} else {
    initAwardsCarouselSwipers();
}
